var React = require('react');

function HorizontalDashInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.3","fillRule":"evenodd","clipRule":"evenodd","d":"M12 22.7992C17.9646 22.7992 22.8 17.9639 22.8 11.9992C22.8 6.03454 17.9646 1.19922 12 1.19922C6.03528 1.19922 1.19995 6.03454 1.19995 11.9992C1.19995 17.9639 6.03528 22.7992 12 22.7992Z","fill":"#BEC4D5","key":0}),React.createElement("rect",{"x":"7","y":"10.5","width":"10","height":"3","fill":"#9FA6BB","key":1})]);
}

HorizontalDashInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = HorizontalDashInline;

HorizontalDashInline.default = HorizontalDashInline;
